import { Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { environment } from 'src/app/environments/environments.dev';
import * as moment from 'moment';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ModalSeeBinnacleComponent } from 'src/app/components/crud/modal-see-binnacle/modal-see-binnacle.component';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ModalWorkOrdersComponent } from 'src/app/components/crud/modal-work-orders/modal-work-orders.component';
import { ModalNewBinnacleComponent } from 'src/app/components/crud/modal-new-binnacle/modal-new-binnacle.component';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-list-binnacle',
  templateUrl: './list-binnacle.component.html',
  styleUrls: ['./list-binnacle.component.css'],
  animations: [
    trigger('buttonAnimation', [
      transition('* => *', [
        animate('0.5s ease-in-out', style({ transform: 'scale(1.1)' })),
        animate('0.5s ease-in-out', style({ transform: 'scale(1)' })),
      ]),
    ]),
  ],
})
export class ListBinnacleComponent {
  modalRef: MdbModalRef<ModalSeeBinnacleComponent> | null = null;
  modalRefWorkOrder: MdbModalRef<ModalWorkOrdersComponent> | null = null;
  modalRefNewBinnacle: MdbModalRef<ModalNewBinnacleComponent> | null = null;
  loadingFull: boolean = false;
  loading: any;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  requestBinnaclesPaginated: any[] = [];
  headers: any = [
    {
      label: '#',
      field: 'id',
      disableSort: false,
    },
    {
      label: 'Línea',
      field: 'production_line',
      disableSort: false,
    },
    {
      label: 'Equipo',
      field: 'production_equipment',
      disableSort: false,
    },
    {
      label: 'Especialidad',
      field: 'production_speciality',
      disableSort: false,
    },
    {
      label: 'Solicitante',
      field: 'creator_user',
      disableSort: false,
    },
    {
      label: 'Fecha creación',
      field: 'created_at',
      disableSort: false,
    },
    {
      label: 'Estado',
      field: 'status',
      disableSort: false,
    },
    {
      label: 'Acciones',
      field: '',
      disableSort: false,
    },
  ];

  requestBinnacles: any[] = [];
  
  createButtonIsVisible: boolean = false;
  seebuttonIsVisible: boolean = false;
  editbuttonIsVisible: boolean = false;
  approveOrRejectbuttonIsVisible: boolean = false;
  newWorkerOrderbuttonIsVisible: boolean = false;
  
  esOptions = {
    title: 'SELECCIONE FECHA',
    monthsFull: [
      'enero','febrero','marzo','abril','mayo','junio',
      'julio','agosto','septiembre','octubre','noviembre','diciembre'
    ],
    monthsShort: ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'],
    weekdaysFull: ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],
    weekdaysShort: ['dom','lun','mar','mié','jue','vie','sáb'],
    weekdaysNarrow: ['D','L','M','X','J','V','S'],
    okBtnText: 'Aceptar',
    clearBtnText: 'Limpiar',
    cancelBtnText: 'Cancelar'
  };

  states: any = [
    { id: 1, name: 'Pendiente' },
    { id: 2, name: 'Aprobada' },
    { id: 3, name: 'Rechazada' },
    { id: 4, name: 'Cerrado' },
  ];

  requestForm: FormGroup;

  constructor(
    private modalService: MdbModalService,
    private crudService: GenericCrudService<any>,
    private fb: FormBuilder
  ) {
    this.requestForm = this.fb.group({
      start_schedule_date: [null],
      end_schedule_date: [null],
      status: [null],
    });
  }

  async ngOnInit(): Promise<void> {
    this.loadingFull = true;
    await Promise.all([this.getRequestBinnacleByCompanyId()]);
    this.visibilityButtonsMenu();
    this.loadingFull = false;
  }

  async filterData(): Promise<void> {
    const startScheduleDate = moment(this.requestForm.get('start_schedule_date')?.value, 'DD-MM-YYYY HH:mm:ss').startOf('day').valueOf();
    const endScheduleDate = moment(this.requestForm.get('end_schedule_date')?.value, 'DD-MM-YYYY HH:mm:ss').endOf('day').valueOf();
    const status = this.requestForm.get('status')?.value;
    await this.getRequestBinnacleByCompanyId();
  
    if(startScheduleDate != null || status != null || endScheduleDate != null) {
      if(startScheduleDate != null  && !Number.isNaN(startScheduleDate)) {
        this.requestBinnacles = this.requestBinnacles.filter((item: any) => {
          if(moment(item.created_at, "DD-MM-YYYY HH:mm:ss").valueOf() >= startScheduleDate) {
            return item;
          }
        });
      }
      if(endScheduleDate != null && !Number.isNaN(endScheduleDate)) {
        this.requestBinnacles = this.requestBinnacles.filter((item: any) => {
          if(moment(item.created_at, "DD-MM-YYYY HH:mm:ss").valueOf() <= moment(endScheduleDate).valueOf()) {
            return item;
          }
        });
      }
      if(status != null && status != '') {
        this.requestBinnacles = this.requestBinnacles.filter((item: any) => {
          if((item.status) == status) {
            return item;
          }
        });
      }
      this.requestBinnacles.sort((a, b) => {
        return b.id - a.id;
      });
      console.log("this.requestBinnacles", this.requestBinnacles);
    }
    this.onPageChange(1);
  }

  visibilityButtonsMenu() {
    const menu = JSON.parse(localStorage.getItem('Menu') ?? '{}');
    const currentMenuId = localStorage.getItem('IdMenu')?.toString(); // Ensure it is transformed to a string
    console.log("menu.detail", menu.detail);
    console.log("currentMenuId", currentMenuId);
    const currentMenu = menu.detail.find((item: any) => item.Menu.id === currentMenuId);
    console.log("currentMenu", currentMenu);
    const buttons = currentMenu?.Menu.BUTTONS ?? [];
    console.log("buttons", buttons);
    buttons.forEach((button: any) => {
      button.BUTTON_ACTION === 'create' ? this.createButtonIsVisible = true : false;
      button.BUTTON_ACTION === 'read' ? this.seebuttonIsVisible = true : false;
      button.BUTTON_ACTION === 'update' ? this.editbuttonIsVisible = true : false;
      button.BUTTON_ACTION === 'approve_or_reject' ? this.approveOrRejectbuttonIsVisible = true : false;
      button.BUTTON_ACTION === 'transfer_binnacle_to_ot' ? this.newWorkerOrderbuttonIsVisible = true : false;
    });
  }

  async getRequestBinnacleByCompanyId(): Promise<void> {
    const body = new FormData();
    const id_company = localStorage.getItem('IdCompany') ?? '';
    body.append('id_company', id_company);
    const response: any = await firstValueFrom(
      this.crudService.crud(body, environment.GetBinnaclesByCompanyId)
    );
    if (response && response.status === 1 && response.data) {
      this.requestBinnacles = response.data.map((item: any) => {
        item.created_at = moment(item.created_at).format('DD-MM-YYYY HH:mm');
        return item;
      });
      this.requestBinnacles = this.requestBinnacles.sort((a, b) => {
        return b.id - a.id;
      });
    }
    this.onPageChange(1);
  }

  updatePaginatedData() {
    const start = this.currentPage * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.requestBinnaclesPaginated = this.requestBinnacles.slice(start, end);
  }

  onPageChange(event: any) {
    this.currentPage = event.page ?? event - 1;
    this.updatePaginatedData();
  }

  async actionBinnacle(event: any, action: string) {
    this.modalRef = this.modalService.open(ModalSeeBinnacleComponent, {
      data: {
        id: event,
        action,
      },
    });
    this.modalRef.onClose.subscribe(async (event: any) => {
      if (!event) {
        return;
      }
      await this.getRequestBinnacleByCompanyId();
    });
  }

  createNewWorkOrder(id_binnacle: string) {
    const selectedBinnacle = this.requestBinnacles.find(
      (item: any) => item.id === id_binnacle
    );
    if (!selectedBinnacle) {
      console.error('Binnacle not found');
      return;
    }
    console.log('selectedBinnacle', selectedBinnacle);
    this.modalRefWorkOrder = this.modalService.open(ModalWorkOrdersComponent, {
      data: {
        id_binnacle,
        productionLineSelected: selectedBinnacle.id_production_line,
        productionEquipmentSelected: selectedBinnacle.id_production_equipment,
        productionSpecialitySelected: selectedBinnacle.id_production_speciality,
      },
    });

    this.modalRefWorkOrder.component.saveEvent.subscribe(() => {
      window.location.href = 'admin/dashboard/crud/listWorkOrders';
    });

    this.modalRefWorkOrder.onClose.subscribe(async (event: any) => {
      if (!event) {
        return;
      }
    });
  }

  createNewBinnacle() {
    this.modalRefNewBinnacle = this.modalService.open(
      ModalNewBinnacleComponent,
    );
    this.modalRefNewBinnacle.onClose.subscribe(async (event: any) => {
      if (!event) {
        return;
      }
      await this.getRequestBinnacleByCompanyId();
    });
  }
}
